import HelpLink from 'App/HelpLink';
import { DEFAULT_LANGUAGE, HELP_LINKS_FREE_SHIPPING } from 'commons/constants';
import { useTranslationLanguage } from 'commons/hooks';
import { useTranslationMarketing } from 'domains/Marketing/hook';

export function FreeShippingHelpLink() {
  const t = useTranslationMarketing('freeShipping');
  const language = useTranslationLanguage();

  return (
    <HelpLink
      title={t('helpLink.text')}
      linkURL={
        HELP_LINKS_FREE_SHIPPING[language] ??
        HELP_LINKS_FREE_SHIPPING[DEFAULT_LANGUAGE]
      }
      icon="both"
      currentViewTracking={t('helpLink.trackingName')}
      previousValue="free_shipping_list"
      showInMobile
    />
  );
}
